import router from './router'
import Vue from 'vue'
import store from './store'
// import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // getToken from cookie
// import { getUserInfo } from "@/modules/main/api/main'";

const whiteList = ['/login', "/mobileSignup"] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // if (store.getters.roles.length === 0) {
      //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
      //     next()
      //   }).catch((err) => {
      //     store.dispatch('FedLogOut').then(() => {
      //       Message.error(err || 'Verification failed, please login again')
      //       next({ path: '/' })
      //     })
      //   })
      // } else {
      // 如果信息不完善，弹窗提示
      if (JSON.parse(localStorage.getItem('fstat')) == null && localStorage.getItem('userInfo') != null) {
        store.dispatch('getUserInfo', JSON.parse(localStorage.getItem('userInfo')).userId).then(res => {
          console.log('permission', res)
          if (res) {
            localStorage.setItem('fstat', JSON.stringify(res) || '{}')
          } else {
            localStorage.setItem('fstat', '{}')
          }

          if (JSON.parse(localStorage.getItem('fstat')) === 0) {
            Vue.showConfirm()
          }
        })
      } else if (JSON.parse(localStorage.getItem('fstat')) === 0) {
        Vue.showConfirm()
      }
      next()
      // }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      // NProgress.done()
    }
  }
})
router.afterEach(() => {
  // NProgress.done() // 结束Progress
})
